import "./Studio.module.css";
import Header from "@/reusable_sections/Header";
import Gallery from "./sections/Gallery";
import Team from "./sections/Team";
import WhereToFindUs from "./sections/WhereToFindUs";
import RodapeItc from "@/reusable_sections/Footer";
export default function StudioPage() {
  return <div>
      <Header />
      <Gallery />
      <Team />
      <WhereToFindUs />
      <RodapeItc />
    </div>;
}